import type { Activity } from '@paintscout/api'
import React from 'react'
import Highlight from '../Highlight'
import { formatName } from '@paintscout/util/builder'

export interface ActivityContactProps {
  activity: Activity
}

export default function ActivityContact(props: ActivityContactProps) {
  const { activity } = props

  const contact = activity.details.contact
  const name = formatName(contact)

  if (!name) {
    return null
  }

  return (
    <>
      {' '}
      by <Highlight>{name}</Highlight>
    </>
  )
}
